function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-3{fill:currentColor}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "route",
  transform: "translate(5.5 5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Joyn-2-Task-Type-Setup",
  transform: "translate(-50 -173)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-35",
  transform: "translate(44 168)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-23",
  transform: "translate(5.5 5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M12.532 1.049A3.037 3.037 0 0010.118 0a2.372 2.372 0 00-1.667.612C7.244 1.72 7.26 4.052 7.26 6.515c0 1.982 0 4.226-.762 4.926a.854.854 0 01-.619.219 1.519 1.519 0 01-1.239-.51c-.746-.874-.762-2.667-.588-4.2a1.879 1.879 0 01-.286.015 2.786 2.786 0 01-1.159-.248c-.206 1.72-.206 3.964.873 5.247A3.028 3.028 0 005.862 13a2.36 2.36 0 001.652-.612C8.7 11.295 8.7 8.978 8.7 6.515c0-1.982 0-4.241.762-4.955a.894.894 0 01.635-.219 1.5 1.5 0 011.255.525c.746.874.762 2.652.572 4.183a1.879 1.879 0 01.286-.015 2.786 2.786 0 011.159.248c.016-.175.048-.35.064-.539.211-2.158-.091-3.743-.901-4.694z",
  className: "cls-3"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 1,
  cy: 1,
  r: 1,
  className: "cls-3",
  transform: "translate(11.5 7)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M2.5 2a2 2 0 102 2 2 2 0 00-2-2zm0 3a1 1 0 111-1 1 1 0 01-1 1z",
  className: "cls-3"
})))));

var SvgRoute = function SvgRoute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/route.037f8022.svg";
export { ForwardRef as ReactComponent };